import Grid from "@mui/material/Grid";
import {List, ListItem, Typography} from "@mui/material";
import React from "react";


function PublicationItem({ publication }) {
  return (
    <div>
      <Typography variant="h6" component="h3">
        {publication.title}
      </Typography>
      <Typography variant="subtitle1" color="textSecondary">
        {publication.authors}
      </Typography>
      <Typography variant="body2">
        {publication.details}
      </Typography>
      {publication.url && (
        <Typography variant="body2">
          <a href={publication.url} target="_blank" rel="noopener noreferrer">
            Read more
          </a>
        </Typography>
      )}
      {publication.doi && (
        <Typography variant="body2">
          DOI: <a href={`https://doi.org/${publication.doi}`} target="_blank" rel="noopener noreferrer">
            {publication.doi}
          </a>
        </Typography>
      )}
    </div>
  );
}


function Publications() {
    const publications = [
            {
      title:
        "Average-Case Hardness of Parity Problems: Orthogonal Vectors, k-SUM and More",
      authors:
        "Mina Dalirrooyfard, Andrea Lincoln, Barna Saha, Virginia Vassilevska Williams",
      details: "SODA 2025 (New Orleans, LA, January 12–15, 2025)",
      url: "https://doi.org/10.1137/1.9781611978322.158",
      doi: "10.1137/1.9781611978322.158",
    },
    {
      title:
        "Worst-Case and Average-Case Hardness of Hypercycle and Database Problems",
      authors: "Cheng-Hao Fu, Andrea Lincoln, Rene Reyes",
      details: "ICALP 2025 ",
      url: "https://doi.org/10.48550/arXiv.2504.18640",
      doi: "10.48550/ARXIV.2504.18640",
    },
    {
      title: "Towards a Law of Iterated Expectations for Heuristic Estimators",
      authors:
        "Paul F. Christiano, Jacob Hilton, Andrea Lincoln, Eric Neyman, Mark Xu",
      details: "CoRR 2024 (arXiv: 2410.01290)",
      url: "https://doi.org/10.48550/arXiv.2410.01290",
      doi: "10.48550/ARXIV.2410.01290",
    },
      {
        title: "Quasipolynomiality of the Smallest Missing Induced Subgraph",
        authors: "David Eppstein, Andrea Lincoln, Virginia Vassilevska Williams",
        details: "Journal of Graph Algorithms and Applications 2023",
        url: "https://doi.org/10.7155/jgaa.00625",
        doi: "10.7155/jgaa.00625"
      },
      {
        title: "The Complexity of Average-Case Dynamic Subgraph Counting",
        authors: "Monika Henzinger, Andrea Lincoln, Barna Saha",
        details: "SODA 2022",
        url: "https://doi.org/10.1137/1.9781611977073.23",
        doi: "10.1137/1.9781611977073.23"
      },
      {
        title: "How Compression and Approximation Affect Efficiency in String Distance Measures",
        authors: "Arun Ganesh, Tomasz Kociumaka, Andrea Lincoln, Barna Saha",
        details: "SODA 2022",
        url: "https://doi.org/10.1137/1.9781611977073.112",
        doi: "10.1137/1.9781611977073.112"
      },
      {
        title: "Delegation for Search Problems",
        authors: "Justin Holmgren, Andrea Lincoln, Ron D. Rothblum",
        details: "ICALP 2022",
        url: "https://doi.org/10.4230/LIPIcs.ICALP.2022.73",
        doi: "10.4230/LIPIcs.ICALP.2022.73"
      },
      {
        title: "New Techniques for Proving Fine-Grained Average-Case Hardness",
        authors: "Mina Dalirrooyfard, Andrea Lincoln, Virginia Vassilevska Williams",
        details: "FOCS 2020",
        url: "https://doi.org/10.1109/FOCS46700.2020.00077",
        doi: "10.1109/FOCS46700.2020.00077"
      },
      {
        title: "Faster Random k-CNF Satisfiability",
        authors: "Andrea Lincoln, Adam Yedidia",
        details: "ICALP 2020 [Invited to special issue of Theory of Computing Systems]",
        url: "https://doi.org/10.4230/LIPIcs.ICALP.2020.78",
        doi: "10.4230/LIPIcs.ICALP.2020.78"
      },
      {
        title: "Closing the Gap Between Cache-oblivious and Cache-adaptive Analysis",
        authors: "Michael Bender, Rezaul Chowdhury, Rathish Das, Rob Johnson, William Kuszmaul, Andrea Lincoln, Quanquan Liu, Jayson Lynch, Helen Xu",
        details: "SPAA 2020",
        url: "https://doi.org/10.1145/3350755.3400274",
        doi: "10.1145/3350755.3400274"
      },
      {
        title: "Algorithms and Lower Bounds for Cycles and Walks: Small Space and Sparse Graphs",
        authors: "Andrea Lincoln and Nikhil Vyas",
        details: "ITCS 2020",
        url: "https://doi.org/10.4230/LIPIcs.ITCS.2020.11",
        doi: "10.4230/LIPIcs.ITCS.2020.11"
      },
      {
        title: "Monochromatic triangles, intermediate matrix products, and convolutions",
        authors: "Andrea Lincoln, Adam Polak, Virginia Vassilevska Williams",
        details: "ITCS 2020, short presentation at HALG'20",
        url: "https://doi.org/10.4230/LIPIcs.ITCS.2020.53",
        doi: "10.4230/LIPIcs.ITCS.2020.53"
      },
      {
        title: "Public-Key Cryptography: in the Fine-Grained Setting",
        authors: "Rio LaVigne, Andrea Lincoln, Virginia Vassilevska Williams",
        details: "CRYPTO 2019",
        url: "https://doi.org/10.1007/978-3-030-26954-8_20",
        doi: "10.1007/978-3-030-26954-8_20"
      },
      {
        title: "Cache-Adaptive Exploration: Experimental Results and Scan-Hiding for Adaptivity",
        authors: "Andrea Lincoln, Quanquan Liu, Jayson Lynch, Helen Xu",
        details: "SPAA 2018",
        url: "https://doi.org/10.1145/3210377.3210382",
        doi: "10.1145/3210377.3210382"
      },
      {
        title: "Fine-grained I/O Complexity via Reductions: New lower bounds, faster algorithms, and a time hierarchy",
        authors: "Erik Demaine, Andrea Lincoln, Quanquan Liu, Jayson Lynch, Virginia Vassilevska Williams",
        details: "ITCS 2018",
        url: "https://doi.org/10.4230/LIPIcs.ITCS.2018.34",
        doi: "10.4230/LIPIcs.ITCS.2018.34"
      },
      {
        title: "Tight Hardness for Shortest Cycles and Paths in Sparse Graphs",
        authors: "Andrea Lincoln, Virginia Vassilevska Williams, Ryan R. Williams",
        details: "SODA 2018",
        url: "https://doi.org/10.1137/1.9781611975031.80",
        doi: "10.1137/1.9781611975031.80"
      },
      {
        title: "Conditional Hardness for Sensitivity Problems",
        authors: "Monika Henzinger, Andrea Lincoln, Stefan Neumann, Virginia Vassilevska Williams",
        details: "ITCS 2017",
        url: "https://doi.org/10.4230/LIPIcs.ITCS.2017.26",
        doi: "10.4230/LIPIcs.ITCS.2017.26"
      },
      {
        title: "Total Tetris: Tetris with Monominoes, Dominoes, Trominoes, Pentominoes,...",
        authors: "Erik D Demaine, Martin L Demaine, Sarah Eisenstat, Adam Hesterberg, Andrea Lincoln, Jayson Lynch, Y William Yu",
        details: "Journal of Information Processing 2017",
        url: "https://doi.org/10.2197/ipsjjip.25.515",
        doi: "10.2197/ipsjjip.25.515"
      },
      {
        title: "Deterministic Time-Space Tradeoffs for k-SUM",
        authors: "A. Lincoln, V. Vassilevska Williams, J. R. Wang, R. R. Williams",
        details: "ICALP 2016",
        url: "https://doi.org/10.4230/LIPIcs.ICALP.2016.58",
        doi: "10.4230/LIPIcs.ICALP.2016.58"
      },
      {
        title: "Cache-Adaptive Analysis",
        authors: "Michael Bender, Erik Demaine, Roozbeh Ebrahimi, Jeremy Fineman, Rob Johnson, Andrea Lincoln, Jayson Lynch, Samuel Mccauley",
        details: "SPAA 2016; HALG 2017",
        url: "https://doi.org/10.1145/2935764.2935798",
        doi: "10.1145/2935764.2935798"
      },
      {
        title: "The one-out-of-k retrieval problem and Linear Network Coding",
        authors: "Giuseppe Bianchi, Lorenzo Bracciale, Keren Censor-Hillel, Andrea Lincoln, Muriel Medard",
        details: "Advances in Mathematics of Communications AMC; ICMCTA 2014",
        url: "https://doi.org/10.3934/AMC.2016.10.95",
        doi: "10.3934/AMC.2016.10.95"
      },
    ];
    return(
        <Grid container justifyContent="left">
          <Grid item xs={12} md={8} lg={6}>
            <List className="publication-list">
              {publications.map((pub, index) => (
                <ListItem key={index} className="publication-item">
                  <PublicationItem publication={pub} />
                </ListItem>
              ))}
            </List>
          </Grid>
        </Grid>
    );
}

export default Publications;
